import { useQueryClient } from "@tanstack/react-query";
import { Select, SelectProps } from "antd";
import { useUsersServiceGetUsers, useUsersServiceGetUsersKey } from "api/queries";
import queryString from "qs";
import { useEffect, useState } from "react";

interface IUserSelectProps {
  isForm?: boolean;
  onChange?: (value: any) => void;
  value?: string | number | null;
  items?: any[];
  selectProps?: Partial<SelectProps>;
}

const UserSelectWithForm: React.FC<IUserSelectProps> = ({
  isForm,
  onChange,
  value,
  items,
  selectProps,
}) => {
  const [filters, setFilters] = useState("");
  const queryClient = useQueryClient();

  const { data, isLoading, isRefetching, refetch } = useUsersServiceGetUsers(
    {
      filters,
      pagination: "",
      sort: "",
    },
    [useUsersServiceGetUsersKey]
  );

  const handleFilter = (value: string) => {
    setFilters(
      value ? queryString.stringify({ userName: { $ilike: `${value}%` } }) : ""
    );
  };

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [useUsersServiceGetUsersKey],
    });
  }, [filters]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        //@ts-ignore
        onChange(v);
      }}
      showSearch
      allowClear
      loading={isLoading || false}
      placeholder="Select a user"
      notFoundContent={false}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      {...selectProps}
      onSearch={handleFilter}
      onClear={() => {
        //@ts-ignore
        onChange(null);
        selectProps?.onClear?.();
      }}
      options={
        data?.items?.map((_v: any) => {
          return {
            label: _v.userFullName,
            value: _v.idUser,
            key: _v.idUser + "-user-id-select-user",
          };
        }) ?? []
      }
    />
  );
};

const UserSelectNoForm: React.FC<IUserSelectProps> = ({
  isForm,
  onChange,
  value,
  items,
  selectProps,
}) => {
  const [filters, setFilters] = useState("");
  const queryClient = useQueryClient();

  const { data, isLoading, isRefetching } = useUsersServiceGetUsers(
    {
      filters,
      pagination: "",
      sort: "",
    },
    [useUsersServiceGetUsersKey]
  );

  const handleFilter = (value: string) => {
    setFilters(
      value ? queryString.stringify({ userName: { $ilike: `${value}%` } }) : ""
    );
  };

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [useUsersServiceGetUsersKey],
    });
  }, [filters]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        const user = data?.items?.find((i: any) => i.idUser === v);
        //@ts-ignore
        onChange(user);
      }}
      showSearch
      allowClear
      loading={isLoading || isRefetching}
      placeholder="Search a user"
      notFoundContent={null}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      options={
        data?.items?.map((_v: any) => {
          return {
            label: _v.userName,
            value: _v.idUser,
            key: _v.idUser + "-user-id-select-user-no-form",
          };
        }) ?? []
      }
      onSearch={handleFilter}
      {...selectProps}
    />
  );
};

const UserSelect: React.FC<IUserSelectProps> = ({ isForm, ...rest }) => {
  if (isForm) {
    return <UserSelectWithForm {...rest} />;
  }
  return <UserSelectNoForm {...rest} />;
};

export default UserSelect;
